import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { UnauthorisedComponent } from './unauthorised/unauthorised.component';
import { BypassLoginComponent } from './bypass-login/bypass-login.component';
import { ButtonComponent } from "../../shared/button/button.component";

@NgModule({
  declarations: [UnauthorisedComponent, BypassLoginComponent],
  exports: [
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    ButtonComponent,
  ]
})
export class AuthModule { }
